import React from 'react';
import { ColumnItem } from '../column-item';
import { ImageContent } from './image-content';
export function Image(props) {
    var _a = props.align, align = _a === void 0 ? 'center' : _a, cssClass = props.cssClass, href = props.href, _b = props.padding, padding = _b === void 0 ? '10px 25px' : _b, src = props.src;
    return (React.createElement(ColumnItem, { align: align, padding: padding, cssClass: cssClass },
        React.createElement(ImageContent, { src: src, href: href })));
}
//# sourceMappingURL=image.js.map